import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { ArrowLeftIcon } from "../../../../../assets/images/icon";
import { moveBack } from "../../../../../system";
import {
  Directions,
  leaderboardConstants,
  translationConstants,
} from "../../../../../constants";
import { competitionActions } from "../../../../../redux/actions";
import {
  loadingIndicator,
  dataEndMessage,
} from "../../../../../shared/utilitiies";

import FilterComponent from "./FilterComponent";
import LeaderboardRankCard from "../../../../../shared/components/LeaderboardRankCard/LeaderboardRankCard";

const defaultQueryExpression = "";
const initialGridState = {
  length: 15,
  search: "",
  pageNumber: 1,
  orderBy: "",
  filterQuery: defaultQueryExpression,
};

const CompetitionLeaderboard = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();

  const [topRanks, setTopRanks] = useState([]);
  const [otherRanks, setOtherRanks] = useState([]);
  const [gridState, setGridState] = useState(initialGridState);

  const direction = useSelector(
    (state) => state.LanguageChangeReducer.direction
  );
  const ranking = useSelector(
    (state) => state?.leaderboardReducer?.competitionRankings
  );

  useEffect(() => {
    setTopRanks(ranking?.pageData?.filter((comp) => comp.rank <= 3));
    setOtherRanks(ranking?.pageData?.filter((comp) => comp.rank > 3));
    // eslint-disable-next-line
  }, [ranking]);

  useEffect(() => {
    dispatch(
      competitionActions.getCompetitionDetailResult(
        location.state?.competition?.id
      )
    );
    dispatch(
      competitionActions.getCompetitionLeaderboardBoatClasses(
        location.state?.competition?.id
      )
    );
    // eslint-disable-next-line
  }, []);

  //-------Get More Centers List on Scroll
  const getMoreRankingDetails = () => {
    const updatedGridState = { ...gridState, length: (gridState.length += 15) };
    setGridState(updatedGridState);
  };

  const setMedalType = (index) => {
    if (index == 1) {
      return leaderboardConstants.GOLD_MEDAL;
    }
    if (index == 2) {
      return leaderboardConstants.SILVER_MEDAL;
    }
    if (index == 3) {
      return leaderboardConstants.BRONZE_MEDAL;
    }
  };

  return (
    <div className="row">
      <div className="col-md-10 leaderboard">
        <div className="d-flex col-md-12 px-md-4">
          <span
            className="cursor-pointer rotated-element d-flex align-items-start px-4 px-md-4 px-lg-0"
            onClick={moveBack}
          >
            <img src={ArrowLeftIcon} alt="backIcon" className="pt-3" />
          </span>
          <div className="d-flex flex-column">
            <span className="page-heading mx-4">
              {direction === Directions.rtl
                ? location.state?.competition?.arabicTitle
                  ? location.state?.competition?.arabicTitle
                  : location.state?.competition?.title
                : location.state?.competition?.title}
            </span>
            <span className="d-none d-md-block font-20 font-weight-700 text-green mx-4">
              {t(translationConstants.leaderboard)}
            </span>
          </div>
        </div>

        <div className="px-3 px-sm-5 my-3">
          <FilterComponent gridState={gridState} setGridState={setGridState} />
        </div>

        <div className="px-3 px-sm-5 mx-md-3">
          {topRanks?.length > 0 && (
            <div className="">
              <div className="">
                {topRanks?.map((userData, index) => (
                  <LeaderboardRankCard
                    key={index}
                    userData={userData}
                    medal={setMedalType(userData?.rank)}
                  />
                ))}
              </div>
            </div>
          )}

          <div className="">
            <div className="d-flex justify-content-center">
              <InfiniteScroll
                dataLength={otherRanks?.length ?? 0}
                next={getMoreRankingDetails}
                hasMore={
                  otherRanks?.length % 4 === 0 && otherRanks?.length !== 0
                    ? true
                    : false
                }
                loader={loadingIndicator(t)}
                endMessage={dataEndMessage(t, otherRanks)}
                style={{ overflow: "hidden" }}
                scrollableTarget={"main-container"}
              >
                {otherRanks?.map((userData, index) => (
                  <LeaderboardRankCard
                    key={index}
                    isLowerRanks={true}
                    userData={userData}
                  />
                ))}
              </InfiniteScroll>
            </div>
          </div>
        </div>
      </div>

      {/* Temporarily Hidden  */}
      {/* <div className="col-md-2 col-12 sponser-side">
        <SponserSideBar />
      </div> */}
    </div>
  );
};

export default CompetitionLeaderboard;
